import {
  Input,
  Output,
  OnInit,
  Component,
  OnChanges,
  OnDestroy,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UserMenu, GlobalUserInfo } from 'src/app/app.model';
import { DashboardService } from 'src/app/dashboard/dashboard.service';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.scss'],
})
export class SideNavbarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isDay: boolean;
  @Input() sidenav: MatSidenav;
  @Input() menuData: UserMenu[];
  @Input() userInfo: GlobalUserInfo;
  @Input() isMenuOpened: boolean | any;
  userObj: any;

  @Output() profileAction: EventEmitter<string> = new EventEmitter<string>();
  destroy: Subject<any> = new Subject<any>();
  constructor(
    private dashService: DashboardService
  ) { }

  ngOnInit(): void {
    // console.log(this.userInfo)
    this.subscribeObservables();
  }

  ngOnDestroy(): void {
    this.destroy.next(null);
    this.destroy.complete();
  }

  subscribeObservables(): void {
    this.dashService.userInfo
      .pipe(takeUntil(this.destroy))
      .subscribe((r) => {
        if (!!r) {
          this.userObj = r;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.menuData && !!changes.menuData.currentValue) {
    }
  }

  onProfileAction(event: string): void {
    this.profileAction.emit(event);
  }
}
